(function () {
  'use strict';
  if (window.veeryAvisoCookies) return;

  var raiz = document.documentElement;
  var vck = document.getElementById('VeeryCookies');
  var pastilla = document.getElementById('VeeryCookiesPastilla');
  if (!vck || !pastilla) return;

  var conPastilla = vck.getAttribute('data-pastilla') !== 'false';
  var sws = Array.prototype.slice.call(vck.querySelectorAll('.vck__sw'));
  var CATS = ['preferences', 'analytics', 'marketing'];
  var cp = null;
  var iniciado = false;
  var cargadaEn = Date.now();
  var NOTA = 'veery-ck-decidido';
  var VISTOS = 'viewedProducts';

  var VIDA = 365 * 24 * 60 * 60 * 1000;

  function anotar(datos) {
    try {
      localStorage.setItem(NOTA, JSON.stringify({ t: Date.now(), v: datos }));
    } catch (e) {}
  }

  function olvidarVistos(forzar) {
    try {
      if (forzar || (cp && cp.preferencesProcessingAllowed && !cp.preferencesProcessingAllowed())) localStorage.removeItem(VISTOS);
    } catch (e) {}
  }

  function leerNota() {
    try {
      var n = JSON.parse(localStorage.getItem(NOTA) || 'null');
      if (typeof n === 'number') return { t: n };
      if (!n || typeof n.t !== 'number' || Date.now() - n.t > VIDA) return null;
      return n;
    } catch (e) {
      return null;
    }
  }

  function porHistorial() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      return !!nav && nav.type === 'back_forward' && !!leerNota();
    } catch (e) {
      return false;
    }
  }

  function decididoDespues() {
    try {
      var n = leerNota();
      return !!n && n.t > cargadaEn;
    } catch (e) {
      return false;
    }
  }

  var reservado = '';

  function reservar() {
    var alto = vck.hidden ? 0 : Math.min(vck.getBoundingClientRect().height, window.innerHeight * 0.6);
    var valor = alto > 0 ? Math.round(alto) + 'px' : '';
    if (valor === reservado) return;
    reservado = valor;
    raiz.style.scrollPaddingBottom = valor;
  }

  function vista(v) {
    vck.setAttribute('data-view', v);
    reservar();
  }

  function consentimiento() {
    try {
      return (cp && cp.currentVisitorConsent && cp.currentVisitorConsent()) || {};
    } catch (e) {
      return {};
    }
  }

  function decidido() {
    var c = consentimiento();
    return CATS.some(function (k) {
      return c[k] === 'yes' || c[k] === 'no';
    });
  }

  function rellenar() {
    var c = consentimiento();
    sws.forEach(function (s) {
      s.setAttribute('aria-checked', c[s.getAttribute('data-cat')] === 'yes' ? 'true' : 'false');
    });
  }

  function enfocar(el) {
    if (el) el.focus({ preventScroll: true });
  }

  function abrir(v) {
    rellenar();
    vista(v || 'banner');
    raiz.classList.add('veery-ck-propio');
    vck.hidden = false;
    pastilla.hidden = true;
    reservar();
    if (v === 'prefs') enfocar(vck.querySelector('[data-vck="volver"]'));
  }

  function cerrar() {
    var teniaFoco = vck.contains(document.activeElement);
    vck.hidden = true;
    reservar();
    if (conPastilla) {
      pastilla.hidden = false;
      if (teniaFoco) enfocar(pastilla);
    } else if (teniaFoco) {
      document.activeElement.blur();
    }
  }

  function guardar(valores) {
    var datos = {
      preferences: !!valores.preferences,
      analytics: !!valores.analytics,
      marketing: !!valores.marketing,
      sale_of_data: !!valores.marketing
    };
    anotar(datos);
    if (!datos.preferences) olvidarVistos(true);
    if (!cp || !cp.setTrackingConsent) {
      cerrar();
      return;
    }
    try {
      cp.setTrackingConsent(datos, function () {
        cerrar();
      });
    } catch (e) {
      cerrar();
    }
  }

  function cargar(listo) {
    var S = window.Shopify;
    if (cp) return listo();
    if (!S || !S.loadFeatures) {
      if (S && S.customerPrivacy && S.customerPrivacy.shouldShowBanner) cp = S.customerPrivacy;
      return listo();
    }
    S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) cp = window.Shopify.customerPrivacy || null;
      listo();
    });
  }

  function iniciar() {
    if (iniciado) return;
    iniciado = true;
    cargar(function () {
      if (!cp) {
        raiz.classList.remove('veery-ck-propio');
        return;
      }
      olvidarVistos(false);
      var mostrar = false;
      try {
        mostrar = cp.shouldShowBanner();
      } catch (e) {}
      var nota = leerNota();
      if (mostrar && !decidido() && nota && nota.v && cp.setTrackingConsent) {
        try {
          cp.setTrackingConsent(nota.v, function () {});
        } catch (e) {}
        if (conPastilla) pastilla.hidden = false;
      } else if (mostrar && !decidido() && !porHistorial()) {
        abrir('banner');
      } else if (conPastilla && decidido()) {
        pastilla.hidden = false;
      }
    });
  }

  vck.addEventListener('click', function (e) {
    var sw = e.target.closest('.vck__sw');
    if (sw) {
      sw.setAttribute('aria-checked', sw.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
      return;
    }
    var b = e.target.closest('[data-vck]');
    if (!b) return;
    var accion = b.getAttribute('data-vck');
    if (accion === 'gestionar') {
      rellenar();
      vista('prefs');
      enfocar(vck.querySelector('[data-vck="volver"]'));
    } else if (accion === 'volver') {
      vista('banner');
      enfocar(vck.querySelector('[data-vck="gestionar"]'));
    } else if (accion === 'aceptar' || accion === 'todas') {
      guardar({ preferences: true, analytics: true, marketing: true });
    } else if (accion === 'rechazar') {
      guardar({});
    } else if (accion === 'guardar') {
      var v = {};
      sws.forEach(function (s) {
        v[s.getAttribute('data-cat')] = s.getAttribute('aria-checked') === 'true';
      });
      guardar(v);
    }
  });

  vck.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && vck.getAttribute('data-view') === 'prefs') {
      vista('banner');
      enfocar(vck.querySelector('[data-vck="gestionar"]'));
    }
  });

  function abrirPreferencias() {
    cargar(function () {
      abrir('prefs');
    });
  }

  pastilla.addEventListener('click', abrirPreferencias);
  window.addEventListener('resize', function () {
    if (!vck.hidden) reservar();
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-veery-ck-abrir]')) {
      e.preventDefault();
      abrirPreferencias();
    }
  });

  function revisar() {
    if (vck.hidden || vck.getAttribute('data-view') !== 'banner') return;
    if ((cp && decidido()) || decididoDespues()) cerrar();
  }

  document.addEventListener('visitorConsentCollected', function () {
    olvidarVistos(false);
    revisar();
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) revisar();
  });
  window.addEventListener('storage', function (e) {
    if (e.key === NOTA) revisar();
  });

  window.veeryAvisoCookies = { abrir: abrirPreferencias };

  raiz.classList.add('veery-ck-propio');
  if (document.readyState === 'complete') {
    iniciar();
  } else {
    window.addEventListener('load', iniciar, { once: true });
    setTimeout(iniciar, 600);
  }
})();
